// REFSIX-819: what a One Minute Timer was started for. The value decides the
// wording of the alert when the minute is up.
export enum OneMinuteTimerType {
    sub = "sub",
    injury = "injury",
}

// Where a One Minute Timer is at a given moment. A timer whose period ended
// before its minute was up is stopped, and never raises its alert.
export enum OneMinuteTimerStatus {
    running = "running",
    expired = "expired",
    stopped = "stopped",
}
